import { useModalStore } from "@/hooks/Modal/hooks";
import { Button } from "antd";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import ShopAdvancedSettingModal from "./ShopAdvancedSettingModal";

interface ShopAdvancedSettingButtonProps {
    shopId: number;
}

const ShopAdvancedSettingButton: React.FC<ShopAdvancedSettingButtonProps> = function (props) {
    const { shopId } = props;

    const modalStore = useModalStore();

    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        const showAdvancedSettingModal = searchParams.get("showAdvancedSettingModal");

        if (!showAdvancedSettingModal) return;

        searchParams.delete("showAdvancedSettingModal");

        history.replace(location.pathname + "?" + searchParams.toString());

        modalStore.openModal(ShopAdvancedSettingModal, { shopId });
    }, []);

    return (
        <Button
            size="small"
            onClick={() => {
                modalStore.openModal(ShopAdvancedSettingModal, {
                    shopId,
                });
            }}
        >
            高级设置
        </Button>
    );
};

export default React.memo(ShopAdvancedSettingButton);
